import React from "react";
import GitHubCalendar from "react-github-calendar";

const Stats = () => {
  return (
    <div style={{width:"95%",margin:"auto",display:"flex",flexDirection:"column",justifyContent:"space-around",alignItems:"center", marginTop:"50px",textAlign:"center"}}>
      <h1>Git calendar</h1>
      <GitHubCalendar username="nsalunkhe"/>
      <h1>Git Stats</h1>
      <img src="http://github-profile-summary-cards.vercel.app/api/cards/stats?username=nsalunkhe&theme=default" alt="stats" style={{backgroundColor:'#f8f8ff'}}/>
    </div>
  );
};
export default Stats;